/* LINE友だち限定 先着10名 15%OFF — shared browser/server definition.
 *
 * The seat limit is real: Shopify code discount gid://shopify/DiscountCodeNode/1487762522370
 * carries usageLimit (at most 10), appliesOncePerCustomer=true and the native endsAt below.
 * The pool SHRINKS over time (Operator, 2026-09-28): `scheduledSeats` says how many seats may
 * be open at each share of the window left, and lib/gentei10-seats.js sets the Shopify
 * usageLimit to `used + open` (a purchase dips one seat for 20 minutes). So the number
 * shown to a customer is always the number Shopify will still accept.
 * See docs/gentei10-2026.md.
 */
(function(root,factory){if(typeof module==='object'&&module.exports)module.exports=factory();else root.MonobloccGentei10=factory();})(typeof globalThis!=='undefined'?globalThis:this,function(){
  'use strict';
  var startsAt='2026-09-28T15:45:00+09:00';
  // 2026-09-30 Operator: offer extended from 21:00 to midnight. The seat-drop schedule keeps
  // its original 21:00 end; the last window holds 2 seats (Operator 9/30: "2 seats left") until 24:00.
  var endsAt='2026-10-01T00:00:00+09:00';
  var scheduleEndsAt='2026-09-30T21:00:00+09:00';
  function active(now){var t=+(now===undefined?new Date():new Date(now));return t>=Date.parse(startsAt)&&t<Date.parse(endsAt);}
  // `seats` is the watcher's last reading ({remaining}); unknown seats never close the offer,
  // because Shopify is the gate and a stale reading must not hide a seat that still exists.
  function open(now,seats){return active(now)&&!(seats&&seats.remaining===0);}
  // Share of the window still left -> seats that may be open. >80%:9, >50%:8, >20%:3, else 2.
  var schedule=[[0.8,9],[0.5,8],[0.2,3]];
  function leftShare(now){var t=+(now===undefined?new Date():new Date(now)),s=Date.parse(startsAt),e=Date.parse(scheduleEndsAt);return Math.max(0,Math.min(1,(e-t)/(e-s)));}
  function scheduledSeats(now){var l=leftShare(now);for(var i=0;i<schedule.length;i++)if(l>schedule[i][0])return schedule[i][1];return 2;}
  // When the schedule next lowers the pool, or null if it will not drop again.
  function nextDropAt(now){var l=leftShare(now),s=Date.parse(startsAt),e=Date.parse(scheduleEndsAt);for(var i=0;i<schedule.length;i++)if(l>schedule[i][0])return new Date(e-schedule[i][0]*(e-s)).toISOString();return null;}
  return {
    id:'gentei10-2026-09',
    discountId:'gid://shopify/DiscountCodeNode/1487762522370',
    code:'MBLINE10',
    percent:15,
    limit:10,
    startsAt:startsAt,
    endsAt:endsAt,
    scheduleEndsAt:scheduleEndsAt,
    deadlineJa:'9/30(水)24:00まで（日本時間）',
    active:active,
    open:open,
    scheduledSeats:scheduledSeats,
    nextDropAt:nextDropAt
  };
});
